<template>
  <div class="newGroup">
    <MapModal
      :modalNode="modalNode"
      :title="newGroupingCategory.title"
      :id="newGroupingCategory.id"
      :close="closeOneSelf"
    >
      <template slot="content">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="settings"
          label-width="80px"
        >
          <!-- <el-form-item label="选择项目" prop="project">
            <el-select v-model="form.project" placeholder="请选择项目">
              <el-option
                class="selectStyle"
                v-for="item in schemeOptions"
                :label="item.name"
                :value="item.guid"
                :key="item.guid"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="选择成果" prop="scheme">
            <el-select
              v-model="form.scheme"
              @change="getDesignLinesMethod"
              placeholder="请选择成果"
            >
              <el-option
                class="selectStyle"
                v-for="item in schemeOptions"
                :label="item.name"
                :value="item.guid"
                :key="item.guid"
              ></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="选择路线" class=" btns">
            <!-- <el-select
              v-model="form.designLine"
              @change="designLineChange"
              placeholder="请选择路线"
            >
              <el-option
                class="selectStyle"
                v-for="item in designLineOptions"
                :label="item.name"
                :value="item.guid"
                :key="item.guid"
              ></el-option>
            </el-select> -->
            <span
              v-if="selectLineList.length"
              class="lineName"
              @click="openTree"
            >
              <span v-for="item in selectLineList" :key="item.id"
                >{{ item.label }} ->
              </span>
            </span>
            <el-button v-else type="primary" @click="openTree"
              >选择路线方案</el-button
            >
          </el-form-item>

          <el-form-item label="反向行驶" prop="direction">
            <div class="direction">
              <!-- <span>{{ directionList[0] }}</span>
              <i @click="switchFun" class="las la-long-arrow-alt-right"></i>
              <span>{{ directionList[1] }}</span> -->
              <el-switch v-model="reverse" @change="switchFun"> </el-switch>
            </div>
          </el-form-item>

          <el-form-item label="起终点桩号" v-if="startStake">
            <span style="color:aliceblue"
              >{{ startStake }} - {{ endStake }}</span
            >
          </el-form-item>
          <el-form-item label="起点桩号" prop="startStake">
            <el-input v-model="form.startStake"></el-input>
          </el-form-item>
          <el-form-item label="终点桩号" prop="endStake">
            <el-input v-model="form.endStake"></el-input>
          </el-form-item>

          <el-form-item class="submitBtn btns">
            <el-button @click="closeOneSelf">取消</el-button>
            <el-button type="primary" @click="onSubmit('form')">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </MapModal>

    <MapModal
      :modalNode="modalTree"
      :title="newTree.title"
      :id="newTree.id"
      :close="closeModalTree"
    >
      <template slot="content">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="settings"
          label-width="80px"
        >
          <el-form-item class="submitBtn btns">
            <el-button @click="closeModalTree">取消</el-button>
            <el-button type="primary" @click="onSubmit('form')">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </MapModal>
  </div>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
import * as importRouteMap from "./importRoutePage.js";

import {
  getPlansService,
  getLineByPlanService,
  getPointsBySpacingService,
  getGetCarriagewayPoint,
  getGetStake,
  getBimProjectDetail,
  getProjectTree,
  getCarriagewayPoints,
} from "@/api/api";

export default {
  components: {
    MapModal,
  },
  data() {
    return {
      newGroupingCategory: {
        title: "导入数据",
        id: "importRoutePage",
      },
      modalNode: {
        newGroupingCategory: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -400,
          },
          // width: "400px", // 宽度配置 默认450px
          height: "410px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      newTree: {
        title: "选择路线",
        id: "importRoutePage",
      },
      modalTree: {
        newModalTree: {
          show: false, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -730,
          },
          // width: "400px", // 宽度配置 默认450px
          height: "410px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "id", // id和ref使用的同一个
            name: "label", // 树的展示字段 默认name
            expand: true,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            checkeArr: [],
            search: {
              keywords: "label", // 搜素配置关键字 默认是name
            },
            checkBox: true,
            checkBoxClick: this.checkBoxClick,
            nodeClick: this.nodeClick,
          },
        },
      },
      rules: {
        scheme: [{ required: true, message: "选择成果", trigger: "blur" }],
        designLine: [
          { required: true, message: "请选择路线", trigger: "blur" },
        ],
        // startStake: [
        //   { required: true, message: "请输入起点桩号", trigger: "blur" },
        // ],
        // endStake: [
        //   { required: true, message: "请输入起点桩号", trigger: "blur" },
        // ],
      },
      form: {
        project: "",
        scheme: "",
        designLine: "",
        direction: "",
        startStake: "",
        endStake: "",
      },
      schemeOptions: [],
      designLineOptions: [],
      directionList: ["都匀", "安顺"],
      reverse: false,
      planGuid: null,
      designLineGuid: null,
      endStake: "",
      startStake: "",
      selectLineList: [],
    };
  },
  methods: {
    getData() {
      //获取成果下拉数据
      getProjectTree({
        projectGuid: "64d1f27b-e58a-11ed-915e-00505688b0dd",
        // loadVirtualLine:true //是否加载虚拟设计线
        // id: parseInt(window.sessionStorage.getItem("nowProjectId")),
      }).then((res) => {
        console.log(res, "res");
        if (res.data?.data) {
          // this.schemeOptions = JSON.parse(res.data.data.projectResults);
          this.modalTree.newModalTree.content.treeDataJson = [res.data.data];
          if (res.data.data.children.length > 0)
            this.recursion(res.data.data.children);
        }
      });
    },
    // 递归处理树数据
    recursion(data, id) {
      data.forEach((el) => {
        if (el.type == 1) {
          //线路
          const threeObj = [
            {
              i_icon: "small-operation-btn el-icon-view",
              click: (e) => this.lineShowFun(e),
            },
          ];
          el.planGuid = id;
          el.lineShow = false;
          el.selectLineShow = false;
          el.operate = threeObj;
        } else if (el.children.length) {
          this.recursion(el.children, el.id);
        }
      });
    },
    lineShowFun(data) {
      data.lineShow = !data.lineShow;
      if (data.lineShow) {
        getGetStake({
          planGuid: data.planGuid,
          lineGuid: data.id,
        }).then((res) => {
          if (res.data?.data) {
            getGetCarriagewayPoint({
              planGuid: data.planGuid,
              designLineGuid: data.id,
              startStake: res.data.data.startStake,
              endStake: res.data.data.endStake,
              reverse: false,
            }).then((res) => {
              if (res.data?.data.length) {
                let arr = [];
                res.data.data.forEach((el) => {
                  arr.push([el[0], el[1], el[2]]);
                });
                console.log(arr);
                console.log(data.label);
                importRouteMap.drawLine(arr, data.label, data.id);
              } else {
                this.$alert("当前路线暂无数据", "友情提示", {
                  confirmButtonText: "确定",
                  type: "warning",
                  callback: (action) => {},
                });
              }
            });
          }
        });
      } else {
        console.log(data);
        console.log(data.id);
        console.log("**********");
        importRouteMap.deleteGraphic(data.id);
      }
    },
    // 获取路线下拉框数据
    getDesignLinesMethod(data) {
      this.endStake = "";
      this.startStake = "";
      this.form.endStake = "";
      this.form.startStake = "";
      this.planGuid = data;
      getLineByPlanService({
        planGuid: data,
        loadVirtualLine: true,
      }).then((res) => {
        this.form.designLine = null;
        this.designLineOptions = res.data.data;

        // this.$nextTick(() => {
        //   if (this.designLineOptions.length > 0) {
        //     this.form.designLine = this.designLineOptions[0].guid;
        //   }
        // });
      });
    },
    designLineChange(data) {
      this.designLineGuid = data;
      getGetStake({
        planGuid: this.planGuid,
        lineGuid: data,
      }).then((res) => {
        console.log(res);
        if (res.data?.data) {
          this.endStake = res.data.data.endStake;
          this.startStake = res.data.data.startStake;
          this.form.endStake = res.data.data.endStake;
          this.form.startStake = res.data.data.startStake;
        } else {
          this.$alert("当前路线暂无数据", "友情提示", {
            confirmButtonText: "确定",
            type: "warning",
            callback: (action) => {},
          });
        }
      });
    },
    switchFun(v) {
      console.log(v);
      // this.directionList = this.directionList.reverse();
      this.selectLineList = this.selectLineList.reverse();
      this.reverse = v;
      this.batchQuery();
    },
    onSubmit() {
      // console.log(this.selectLineList, "this.selectLineList");

      this.$refs["form"].validate((valid) => {
        if (valid) {
          var result = this.groupBy(
            this.selectLineList,
            "planGuid",
            (a, b, key) => {
              var C1 = a[key].split(" ")[0];
              var C2 = null;
              try {
                C2 = b[key].split(" ")[0];
              } catch (exception) {
                C2 = null;
              }

              return C1 == C2;
            }
          );
          let list = [];
          result.forEach((el) => {
            let arr = [];
            el.forEach((va) => {
              arr.push(va.id);
            });
            let obj = {
              planGuid: el[0].planGuid,
              designLineGuids: arr,
            };
            list.push(obj);
          });
          getCarriagewayPoints(
            //   {
            //   planGuid: this.planGuid,
            //   designLineGuid: this.designLineGuid,
            //   reverse: this.reverse,
            //   startStake: this.form.startStake
            //     ? this.form.startStake
            //     : this.startStake,
            //   endStake: this.form.endStake ? this.form.endStake : this.endStake,
            // }
            {
              startStake: this.form.startStake
                ? this.form.startStake
                : this.startStake,
              endStake: this.form.endStake ? this.form.endStake : this.endStake,
              reverse: this.reverse,
              planInfos: list,
            }
          ).then((res) => {
            let arr = [];

            // res.data.data.forEach((item) => {
            //   arr.push(
            //     mars3d.PointTrans.proj4Trans(
            //       [item[0], item[1], item[2]],
            //       "+proj=tmerc +lat_0=0 +lon_0=107.666666667 +k=1 +x_0=500000 +y_0=0 +a=6379040 +rf=298.257 +units=m +no_defs",
            //       mars3d.CRS.EPSG4326
            //     )
            //   );
            // });
            console.log(res.data.data);
            if (res.data?.data) {
              this.$emit("getPathData", res.data.data);
              importRouteMap.reset();
            }

            // mapWork.createLineEl(arr);
          });
        }
      });
    },
    groupBy(arr, prop, callback) {
      var newArr = [],
        tempArr = [];
      for (var i = 0, j = arr.length; i < j; i++) {
        var result = callback(arr[i], arr[i + 1], prop);

        if (result) {
          tempArr.push(arr[i]);
        } else {
          tempArr.push(arr[i]);
          newArr.push(tempArr.slice(0));
          tempArr.length = 0;
        }
      }

      return newArr;
    },
    openTree() {
      this.modalTree.newModalTree.show = true;
      importRouteMap.reset();
      importRouteMap.createdGraphicLayer();
    },
    checkBoxClick(data) {
      if (data.type == 1 && !data.selectLineShow) {
        data.selectLineShow = true;
        this.selectLineList.push(data);
        console.log(this.selectLineList, "this.selectLineList");
        this.batchQuery();
      } else if (data.type == 1 && data.selectLineShow) {
        this.selectLineList.forEach((el, index) => {
          if (el.id == data.id) {
            this.selectLineList.splice(index, 1);
            data.selectLineShow = false;
          }
        });
        console.log(this.selectLineList, "this.selectLineList");
        this.batchQuery();
      }

      // getCarriagewayPoints({
      //   planGuid: data.planGuid,
      //         designLineGuid: data.id,
      //         startStake: res.data.data.startStake,
      //         endStake: res.data.data.endStake,
      //         reverse: false,
      // }).then(res=>{

      // })
    },
    batchQuery() {
      getGetStake({
        planGuid: this.selectLineList[0].planGuid,
        lineGuid: this.selectLineList[0].id,
      }).then((res) => {
        console.log(res.data, "第一个点");
        if (res.data?.data) {
          this.startStake = res.data.data.startStake;
          this.form.startStake = res.data.data.startStake;

          if (this.selectLineList.length == 1) {
            console.log(res.data.data, "第一个点终点");
            this.endStake = res.data.data.endStake;
            this.form.endStake = res.data.data.endStake;
          }
        }
      });
      if (this.selectLineList.length > 1) {
        getGetStake({
          planGuid: this.selectLineList[this.selectLineList.length - 1]
            .planGuid,
          lineGuid: this.selectLineList[this.selectLineList.length - 1].id,
        }).then((res) => {
          console.log(res.data, "第二个点");
          if (res.data?.data) {
            this.endStake = res.data.data.endStake;
            this.form.endStake = res.data.data.endStake;
          }
        });
      }
      // endStake: "",
      // startStake: "",
    },
    nodeClick(data) {
      console.log(data, "nodeClick");
    },
    closeOneSelf() {
      this.$emit("closeNewGrouping");
    },
    closeModalTree() {
      this.modalTree.newModalTree.show = false;
      importRouteMap.reset();
    },
    beforeDestroy() {},
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.newGroup {
  /deep/.el-form.settings {
    width: 100%;
    @include hvcenter(column);
    // padding: 8px 0 0 0;
    padding: 8px 0 14px 0;
    .el-form-item {
      width: 100%;
      padding: 0 0 0 7px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 18px;
      .el-form-item__label {
        margin-bottom: 0px;
        font-size: 12px;
        @include font_color("t_color_op1");
        padding: 0;
        flex-grow: 0;
        line-height: 32px;
        padding-right: 10px;
      }
      .el-form-item__content {
        margin-left: 0px !important;
        font-size: 12px;
        display: flex;
        align-items: center;
        flex-grow: 1;
        line-height: 32px;
        .el-select {
          @include select_base();
        }
        .el-autocomplete {
          @include select_base();
        }
        .el-input {
          @include input_base();
        }
        .el-textarea {
          @include textarea_base();
        }
        .el-checkbox {
          @include checkbox_base();
        }
      }
      .showInline {
        margin: 10px 6px;
        width: 96px;
        display: inline-block;
        text-align: right;
        @include lheight(26);
        font-size: 11px;
        @include font_color("t_color_op1");
        .el-input-number {
          margin-left: -5px !important;
          @include input_number();
        }
        .el-input-number__increase {
          height: 32px;
          line-height: 32px;
        }
        .el-input__inner {
          width: 100% !important;
        }
      }
      &:first-child {
        padding: 10px 0 0 7px;
      }
      &.description {
        margin-bottom: 12px;
      }

      &.btns {
        margin-bottom: 12px;
        .el-form-item__content {
          width: 166px;
          @include button_primary();
          @include button_default();
        }
      }
    }
    @include switch_base();
    /deep/.el-switch {
      width: 45px;
      margin: 0;
      .el-switch__label {
        width: 28px;
        span {
          width: 28px;
          font-size: 11px;
        }
        &.el-switch__label--left {
          margin-right: 5px;
        }
        &.el-switch__label--right {
          margin-left: 5px;
        }
      }
      .el-switch__core {
        width: 40px !important;
        @include lheight(20);
        margin: 0 5px;
      }
    }
  }
}

.el-radio {
  white-space: break-spaces;
  word-break: break-all;
  .el-radio__input {
    line-height: 18px;
    .el-radio__inner {
      margin: 0 3px 0 0;
      @include background_color("t_color3_op2");
      &::after {
        /* 取消选中状态单选框中间的小圆点显示 */
        display: none;
      }
      &:hover {
        @include border_color("t_color1_op1");
      }
    }
    &.is-checked {
      .el-radio__inner {
        // @include border_color('t_color1_op1');
        // @include background_color('t_color1_op1');
        @include border_color("th_color_op1");
        @include background_color("t_color1_op2");
      }
    }
  }
  .el-radio__label {
    padding-left: 2px;
    font-size: 12px !important;
    color: white;
  }
  &.is-checked {
    .el-radio__label {
      @include font_color("t_color_op1");
    }
    .el-radio__inner {
      background-color: #2281b2 !important;
      // @include background_color("t_color1_op1");
    }
  }
}

/deep/.el-button--default {
  border-color: rgba(255, 255, 255, 0.9) !important;
  background-color: rgba(234, 242, 248, 0.3) !important;
  color: rgba(245, 245, 245, 0.6) !important;
}
.submitBtn {
  display: flex;
  flex-direction: inherit !important;
}
.direction {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  span {
    margin-right: 15px;
  }
  i {
    margin-right: 15px;
    font-size: 18px;
    cursor: pointer;
  }
}
.lineName {
  font-size: 14px;
  color: aliceblue;
}
</style>
